import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import React, { useRef, useState } from "react";
import { paginatorTemplate } from "../../settings-coins/components/paginatorTemplate";
import {
	Button,
	DownloadButton,
	IconButton,
	Modal,
	Textfield,
} from "../../../../components/core";
import { Card } from "primereact/card";
import { Dialog } from "primereact/dialog";
import { InputNumber } from "primereact/inputnumber";
import { InputTextarea } from "primereact/inputtextarea";
import { InputText } from "primereact/inputtext";
import { useMutation } from "@apollo/client";
import { UPDATE_USER_TYPE } from "../../../../constants/graphql/locker-user-types";
import { Strings } from "../../../../constants/strings";

const LockerUserTypeTable = ({
	userTypeData,
	accessPermission,
	operatorId,
}) => {
	const dt = useRef(null);
	const [editDialogOpen, setEditDialogOpen] = useState(false);
	const [changesMade, setChangesMade] = useState(false);
	const [editUserVar, setEditUserVar] = useState({
		userType: "",
		description: "",
		monthlyFee: 0,
	});

	// gql
	const [updateLockerUserType] = useMutation(UPDATE_USER_TYPE);

	// validation
	const [validation, setValidation] = useState({
		icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
		title: "",
		message: "",
		open: false,
	});

	const showError = (title, message) => {
		setValidation({
			icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
			title: title,
			message: message,
			open: true,
			actions: (
				<div className="w-full">
					<Button
						onClick={() => setValidation({ open: false })}
						value={"OK"}
						className={"p-2 w-full"}
					/>
				</div>
			),
		});
	};

	const handleRowClick = (rowData) => {
		console.log({ rowData });
		setEditUserVar(rowData);
	};

	const validateFields = () => {
		if (!editUserVar.userType || !editUserVar.description) {
			showError(
				Strings.popup_error_title,
				Strings.popup_error_title_empty_field
			);
			return;
		}

		if (editUserVar.monthlyFee === 0) {
			showError(
				Strings.popup_error_title,
				"Monetary values cannot be equal to 0"
			);
			return;
		} else {
			editUserData();
		}
	};

	const editUserData = () => {
		updateLockerUserType({
			variables: {
				userTypes: [
					{
						userTypeId: editUserVar.userTypeId,
						operatorId: operatorId,
						userType: editUserVar.userType,
						description: editUserVar.description,
						monthlyFee: editUserVar.monthlyFee,
						sort: 1,
					},
				],
			},
		})
			.then((response) => {
				if (response) {
					setValidation({
						icon: `${process.env.PUBLIC_URL}/assets/images/check.png`,
						// title: Strings.popup_success_title_default,
						message: Strings.popup_success_message_edit,
						open: true,
						actions: (
							<div className="grid grid-cols-1">
								<Button
									onClick={() => {
										setValidation({ open: false });
										window.location.reload();
									}}
									value={"OK"}
									className={"p-2"}
								/>
							</div>
						),
					});
				}
			})
			.catch((error) => {
				if (
					error.message.includes(
						"duplicate key value violates unique constraint"
					)
				) {
					showError(
						Strings.popup_error_title,
						Strings.popup_error_message_duplicate
					);
					return;
				}
			});
	};

	console.log({ editUserVar });
	return (
		<>
			<Card>
				<>
					<DownloadButton dt={dt} csvOnly={true} />

					<DataTable
						value={userTypeData}
						tableStyle={{
							minWidth: "50rem",
							borderWidth: 2,
							borderColor: "#E6E6E6",
						}}
						paginatorTemplate={paginatorTemplate}
						paginator
						paginatorRight
						rows={10}
						stripedRows
						emptyMessage={
							<div className="text-red-500 font-bold">NO RESULT FOUND</div>
						}
						ref={dt}
					>
						<Column
							field="userType"
							alignHeader={"center"}
							header="Locker User Type"
							sortable
							className="  border-x-2 border-b-0 border-x-[#a8a29e]"
							headerStyle={{
								backgroundColor: "#FECD08",
								color: "black",
								border: "2px solid rgb(168 162 158)",
							}}
						/>
						<Column
							field="description"
							header="Description"
							alignHeader={"center"}
							sortable
							className="max-w-[200px] break-words  border-x-2 border-b-0 border-x-[#a8a29e]"
							headerStyle={{
								backgroundColor: "#FECD08",
								color: "black",
								border: "2px solid rgb(168 162 158)",
							}}
						/>
						<Column
							field="monthlyFee"
							header="Monthly Fee"
							alignHeader={"center"}
							sortable
							className=" border-x-2 border-b-0 border-x-[#a8a29e]"
							headerStyle={{
								backgroundColor: "#FECD08",
								color: "black",
								border: "2px solid rgb(168 162 158)",
							}}
							body={(rowData) => <div>₱ {rowData.monthlyFee}</div>}
						/>

						<Column
							key="action"
							field="action"
							className="  border-x-2 border-b-0 border-x-[#a8a29e] w-12"
							headerStyle={{
								backgroundColor: "#FECD08",
								color: "black",
								border: "2px solid rgb(168 162 158)",
							}}
							body={(rowData) => (
								<IconButton
									type="button"
									// icon={`${
									// 	accessPermission.behavioralCampaign === 1 ||
									// 	accessPermission.behavioralCampaign === "1"
									// 		? "pi pi-eye"
									// 		: "pi pi-pencil"
									// }`}
									icon="pi pi-pencil"
									className="bg-primary-primaryYellow text-black border-0 items-center justify-center grid"
									// onClick={() => handleRowClick(rowData, "edit")}
									onClick={() => {
										setEditDialogOpen(true);
										handleRowClick(rowData);
									}}
									// disabled={isLoading || loading}
								/>
							)}
						/>
					</DataTable>
				</>
			</Card>

			<Dialog
				visible={editDialogOpen}
				onHide={() => {
					setEditDialogOpen(false);
				}}
				header="Edit Locker User Type"
				className="w-[450px]"
			>
				<div>
					<div className="grid w-full grid-cols-8 space-y-4">
						<div className="col-span-8 space-y-2">
							<div className="grid grid-cols-5">
								<div className="col-span-5">
									<span className="text-red-500">* </span>Locker User Type
								</div>
								{/* <div className="col-span-8"> */}
								<InputText
									value={editUserVar.userType}
									className="col-span-5"
									maxLength={32}
									pt={{
										root: {
											className: "border border-gray-200 p-1 h-10 rounded-md",
										},
									}}
									onChange={(e) => {
										setEditUserVar({
											...editUserVar,
											userType: e.target.value,
										});
										setChangesMade(true);
									}}
								/>
							</div>
						</div>
						<div className="col-span-8 space-y-2">
							<div className="grid grid-cols-5">
								<div className="col-span-5">
									<span className="text-red-500">* </span>Description
								</div>
								{/* <div className="col-span-8"> */}
								<InputTextarea
									value={editUserVar.description}
									className="col-span-5"
									maxLength={1000}
									rows={4}
									autoResize
									pt={{
										root: {
											className: "border border-gray-200 p-1 rounded-md",
										},
									}}
									onChange={(e) => {
										setEditUserVar({
											...editUserVar,
											description: e.target.value,
										});
										setChangesMade(true);
									}}
								/>
							</div>
							<p className="text-end">
								{editUserVar?.description?.length}/{1000}
							</p>
						</div>
						<div className="col-span-8">
							<div className="grid grid-cols-5  space-y-2">
								<div className="col-span-5">
									<span className="text-red-500">* </span>Monthly Fee
								</div>
								{/* <div className="col-span-8"> */}
								{/* <InputNumber
									inputId="currency-ph"
									mode="currency"
									currency="PHP"
									locale="en-US"
									maxLength={10}
									minFractionDigits={2}
									value={editUserVar.monthlyFee}
									className="col-span-5"
									pt={{
										root: {
											className: "border border-gray-200 p-1 rounded-md",
										},
									}}
									onValueChange={(e) => {
										setEditUserVar({
											...editUserVar,
											monthlyFee: e.target.value,
										});
										setChangesMade(true);
									}}
								/> */}

								<div className="relative col-span-5 flex items-center ">
									{/* <span
										className={`absolute top-1/2 transform -translate-y-1/2 left-3 text-gray-500 z-10`}
									>
										P
									</span> */}
									<Textfield
										type={"text"}
										placeholder="00.00"
										value={editUserVar.monthlyFee}
										prefix={"₱"}
										classNameParent={"w-full"}
										// classNameParent="col-span-5"
										onChange={(e) => {
											// let value = e.target.value;

											// value = value.replace(/[^0-9.]/g, "");

											// // Prevent multiple dots
											// if ((value.match(/\./g) || []).length > 1) {
											// 	return;
											// }

											// // Remove leading zeros (except 0 before a decimal point)
											// if (
											// 	value.startsWith("0") &&
											// 	value.length > 1 &&
											// 	!value.startsWith("0.")
											// ) {
											// 	value = value.replace(/^0+/, "");
											// }

											// // Ensure at least `.00` when a valid number is typed
											// if (value !== "" && !value.includes(".")) {
											// 	value = value + ".00"; // Autofloat format
											// }

											// // Limit decimal places to 2
											// let parts = value.split(".");
											// if (parts.length === 2 && parts[1].length > 2) {
											// 	parts[1] = parts[1].substring(0, 2);
											// 	value = parts.join(".");
											// }

											// // Limit maximum value
											// if (parseFloat(value) > 1000000000) {
											// 	return;
											// }

											let inputValue = e.target.value;
											var numberPattern = /^(\d+(\.\d{0,2})?|\.\d{0,2})?$/;

											if (
												(numberPattern.test(inputValue) &&
													parseFloat(inputValue) <= 1000000000) ||
												inputValue === ""
											) {
												setEditUserVar({
													...editUserVar,
													monthlyFee: inputValue,
												});
											}
											setChangesMade(true);
										}}
									/>
								</div>
							</div>
						</div>
						{/* </div> */}
					</div>

					<div className="pt-6">
						<Button
							value={"Save changes"}
							className={"p-2 mx-auto"}
							onClick={validateFields}
							disabled={
								!changesMade ||
								accessPermission.lockerUserType === 1 ||
								accessPermission.lockerUserType === "1"
							}
						/>
					</div>
				</div>
			</Dialog>

			<Modal
				icon={validation.icon}
				title={validation.title}
				message={validation.message}
				open={validation.open}
				actions={validation.actions}
			/>
		</>
	);
};

export default LockerUserTypeTable;
